
import React, { Component } from 'react';

import "@arco-design/web-react/dist/css/arco.css";
import { Form,Input, Layout, Menu, Space, Card, Carousel,Button,Typography,Modal  } from '@arco-design/web-react';

import * as utils from "../utils.js"
import ScaledImage from '../comp/my-img';
import MyComp from '../comp/my-comp.js';


export default class App extends MyComp{
  constructor(props) {
    super(props);
    let hasLogin = utils.hasLogin()
    this.state = {
      showLogin:false,
      hasLogin: hasLogin,

      winWidth: 0,
      winHeight: 100,
    }

  }
  getCompany5(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let {language} = this.props
    let languageFolder = utils.GetLanguageFolder(language)


    let idx = 5
    let rate = winWidth/2027
    let tipHeight = 1338*rate
    let tipWidth = 1269*rate
    let urlbg = `../imgs/img_banner${idx}.png`
    let url_detail = `../imgs/${languageFolder}img_tip${idx}_detail.png`
    return (<div style={{position:'relative', width: '100vw', height:tipHeight}}>
      <img src={urlbg} style={{width: '100vw', aspectRatio:'auto', position:'absolute', left: 0, top: 0,}} />
      <Space direction='vertical' style={{height: tipHeight*0.88, position:'absolute', right: '6vw', top: '8vw', alignItems:'flex-end', justifyContent:'flex-start'}}>
        <ScaledImage src={url_detail} rate={rate}></ScaledImage>
      </Space>
    </div>
    )
  }

  getBody(){
    return (
      <Space size={0} direction='vertical' style={{width: '100vw', padding:0,margin:0}}>
        {this.getCompany5()}
      </Space>
    )
  }
  render() {
    return (
      <div >
        {this.getBody()}
      </div>
    );
  }
}

